<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Term List">
        <v-card flat class="px-2">
          <form @submit.prevent="termListing">
            <v-row>
              <v-col cols="12" sm="6">
                <span class="font-weight-medium body-2"
                  >Select Class <span class="error--text">*</span></span
                >
                <v-autocomplete
                  class="my-0 py-1"
                  placeholder="--Select--"
                  v-model="classID"
                  required
                  item-text="name"
                  :items="classes"
                  key="id"
                  item-value="id"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="6" sm="6">
                <span class="font-weight-medium body-2">Action</span>
                <div class="inside">
                  <v-btn elevation="1" color="success" type="submit"
                    ><v-icon left>mdi-magnify</v-icon>Search</v-btn
                  >
                </div>
              </v-col>
            </v-row>
          </form>
        </v-card>
        <v-card-component>
          <v-card-text
            class="pt-0 pr-1"
            :class="{
              'd-block py-3': $vuetify.breakpoint.xs,
              'd-flex align-center': $vuetify.breakpoint.smAndUp
            }"
          >
            <v-card-title>
              Total Records : {{ total }}
              <v-spacer></v-spacer>
            </v-card-title>
            <v-text-field
              :class="{
                'mr-0': $vuetify.breakpoint.xs,
                'mr-5': $vuetify.breakpoint.smAndUp
              }"
              v-model="search"
              append-icon="mdi-magnify"
              class="ml-auto mb-2"
              label="Search"
              hide-details
              single-line
              style="max-width: 350px"
            />
            <v-btn
              v-if="isWrite"
              elevation="1"
              v-on:click="addTerm()"
              :class="{ 'mt-2': $vuetify.breakpoint.xs }"
              color="accent"
            >
              <v-icon left>mdi-plus</v-icon>
              Add
            </v-btn>
          </v-card-text>
          <v-divider class="my-0" />
          <v-data-table
            @pagination="getLength"
            :headers="headers"
            v-if="termList.length > 0"
            :items="termList"
            :search="search"
            hide-default-footer
          >
            <template v-slot:item.terms="{ item }">
              {{ item.academicTerm.name }}
            </template>
            <template v-slot:item.actions="{ item }">
              <router-link
                :to="{ name: 'editTerm', params: { termMapID: item.id } }"
              >
                <v-btn
                  class="px-2 ml-1 ma-1"
                  color="success"
                  min-width="0"
                  small
                >
                  <v-icon small> mdi-pencil</v-icon>
                </v-btn>
              </router-link>
            </template>
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center"
                >No Data Available</v-card-subtitle
              >
            </template>
          </v-data-table>
        </v-card-component>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import Utils from '@/utils'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  name: 'termDetails',
  components: { VCardComponent, MaterialCard },
  data () {
    return {
      total: 0,
      search: '',
      franchiseeID: '',
      franchiseeArr: [],
      academicYearID: '',
      academicYears: [],
      termList: [],
      classID: '',
      classes: [],
      isLoading: false,
      isWrite: false,
      headers: [
        { text: 'Terms', value: 'academicTerm.name', sortable: true },
        { text: 'From Date', value: 'fromDate', sortable: true },
        { text: 'To Date', value: 'toDate', sortable: true }
      ]
    }
  },

  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    if (this.isWrite) {
      this.headers.push({
        text: 'Action',
        value: 'actions',
        sortable: false,
        align: 'center'
      })
    }
    try {
      this.isLoading = true
      const { data } = await http.get(
        `${constants.API_URL}/api/franchiseeAcademicYears`
      )
      this.academicYears = data.rows
      const currentAcademicYear = Utils.getCurrentAcademicYear()
      let academicYear = this.academicYears.find((y) => {
        return y.academicYear.trim() === currentAcademicYear.trim()
      })
      this.academicYearID = academicYear ? academicYear.id : ''
    } catch (e) {
      const errorMessage =
        (e && e.response && e.response.data.message) || e.message
      console.log('errorMessage', errorMessage)
    } finally {
      this.isLoading = false
    }
    await this.getFranchiseeList()
    // await this.getYear()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
    await this.classList()
  },
  watch: {
    franchisee: async function (val) {
      this.total = 0
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      this.total = 0
      await this.onFranchiseeChange()
    }
  },
  methods: {
    getLength (pagination) {
      this.total = pagination.itemsLength
    },
    addTerm () {
      this.$router.push({ name: 'addTerm' })
    },
    getFranchiseeList: async function () {
      try {
        this.isLoading = true

        const response = await http.get(
          `${constants.API_URL}/api/franchisee/active`
        )
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.classID = ''
        this.clearClass()
        this.inProgress = false
        if (this.franchiseeID && this.academicYearID) {
          await this.classList()
        }
      }
    },
    termListing: async function () {
      try {
        this.isLoading = true
        let params = {
          academicYearID: this.academicYearID,
          classID: this.classID
        }

        if (this.franchiseeID) {
          params.franchiseeID = this.franchiseeID
        }
        const { data } = await http.get(
          `${constants.API_URL}/api/grade-module/academic-terms/date/map`,
          { params: params }
        )

        this.termList = data
        let x = this.termList.map((a) => {
          a.fromDate = moment(a.fromDate, 'YYYY-MM-DD').format('DD-MM-YYYY')
          return a
        })
        let y = this.termList.map((b) => {
          b.toDate = moment(b.toDate, 'YYYY-MM-DD').format('DD-MM-YYYY')
          return b
        })
        this.termList = x
        this.termList = y
        if (this.termList.length === 0) {
          this.$dialog.error({
            text: 'No Data Found',
            title: 'Error'
          })
        }
        this.total = this.termList.length
        this.isLoading = false
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    classList: async function () {
      try {
        // const studentclasses = await http.get(`${constants.API_URL}/api/student/all-count?franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}`)
        const studentclasses = await http.get(
          `${constants.API_URL}/api/students/class`
        )
        this.classes = studentclasses.data.rows
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    clearClass: function () {
      this.terms = ''
      this.term = ''
      this.termList = ''
      this.ClassID = ''
    }
  }
}
</script>
